import ExpiredPage from './ExpiredPage';

export default ExpiredPage;
